import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { FiUser } from "react-icons/fi";
import HomeLogin2 from "../login/candidateLogin";
import HomeLogin from "../login/employerLogin";
import { FaBars } from "react-icons/fa6";
import { IoMdClose } from "react-icons/io";
import useIntersectionObserver from "./home-animation";
import LoginPopup from "./login-popup";
import CandidateLogin from "./candidate-login";
import CandidateSignIn from "./candidate-signinjsx";
import { useLocation } from 'react-router-dom';
export default function HomeHeader({ siteDetails, scrollToAbout }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [loginsubWrap, SetloginsubWrap] = useState(false);
  const [login1, Setlogin1] = useState(false);
  const [login2, Setlogin2] = useState(false);
  const [sectionRef, isVisible] = useIntersectionObserver({ threshold: 0.1 });
  const [showLoginPopup,setShowLoginPopup]  = useState(false)
  const [showCandidatePopUp, setShowCandidatePopUp] = useState(false)
  const LogIn = () => {
    SetloginsubWrap(!loginsubWrap);
  };
  const candidateLogin = () => {
    // navigate("/candidateLogin");
    setShowCandidatePopUp(true)
  };
  const employerLogin = () => {
    // navigate("/employerLogin");
    setShowLoginPopup(true)
  };
  const closePopup = () => {
    SetloginsubWrap(false);
  };
  const popupRef = useRef(null);
  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      closePopup();
    }
  };
  useEffect(() => {
    if (loginsubWrap) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [loginsubWrap]);
  const [menuShow, setMenuShow] = useState(false);
  const showMenu = () => {
    setMenuShow(!menuShow);
  };
  const hideMenu = () => {
    setMenuShow(!menuShow);
  };
  const hideLoginPopup = () =>{
    setShowLoginPopup(false)
  }
  const hideCandidateLoginPopup = () =>{
    setShowCandidatePopUp(false)
  }

  useEffect(() => {
    if (location.state && location.state.userPopup) {
      setShowLoginPopup(true);
      navigate('/', { replace: true, state: null });
    }
    if(location.state && location.state.candidatePopup){
      setShowCandidatePopUp(true);
      navigate('/', { replace: true, state: null });
    }
  }, [location.state]);
  return (
    <div
      className={`home-header ${isVisible ? "animate__slideInDown" : ""}`}
      style={{ animationDuration: "1.25s" }}
      ref={sectionRef}
    >
      <div className="outer-container">
        <div className="home-inner-header">
          <div className="home-nav-bar">
            <div className="home-logo">
              {siteDetails && siteDetails.company_logo && (
                <Link to="/" aria-label="logo">
                  <img
                    src={siteDetails.company_logo}
                    className="img-fluid"
                    alt="logo"
                    width="140"
                    height="40"
                  />
                </Link>
              )}
            </div>
            <div className="home-nav-items">
              <ul
                className={`home-nav-ul home-nav-mobile ${
                  menuShow ? "show-menu" : ""
                }`}
              >
                <li className="home-nav-li">
                  <Link to="/" className="home-nav-link active">
                    Home
                  </Link>
                </li>
                <li className="home-nav-li" onClick={scrollToAbout}>
                  <Link to="/" className="home-nav-link">
                    About
                  </Link>
                </li>
                <li className="home-nav-li">
                  <Link to="/" className="home-nav-link">
                    Contact
                  </Link>
                </li>
              </ul>
              <ul className="home-nav-ul">
                <li className="position-relative d-block d-lg-none">
                  {menuShow ? (
                    <IoMdClose
                      onClick={() => hideMenu()}
                      style={{ fontSize: "22px" }}
                    />
                  ) : (
                    <FaBars
                      onClick={() => showMenu()}
                      style={{ fontSize: "22px" }}
                    />
                  )}
                </li>
                <li className="position-relative">
                  <button
                    type="button"
                    className="home-page-btn1"
                    onClick={() => LogIn()}
                  >
                    <FiUser style={{ width: "20px", height: "20px" }} />
                    Sign In / Sign Up
                  </button>
                  {loginsubWrap && (
                    <div className="login-subwrap" ref={popupRef}>
                      <div className="d-flex flex-column">
                        <div className="col-lg-12">
                          <button
                            className="btn btn-warning btn-sm mb-2 w-100"
                            onClick={() => candidateLogin()}
                          >
                            Candidate Login
                          </button>
                        </div>
                        <div className="col-lg-12 text-center mb-1">OR</div>
                        <div className="col-lg-12">
                          <button
                            className="btn btn-primary btn-sm w-100"
                            onClick={() => employerLogin()}
                          >
                            Employer Login
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <LoginPopup showLoginPopup={showLoginPopup} hideLoginPopup={hideLoginPopup}/>
      <CandidateLogin showCandidatePopUp={showCandidatePopUp} hideCandidateLoginPopup={hideCandidateLoginPopup}/>
      <CandidateSignIn/>
    </div>
  );
}
